import React, { useState } from 'react';
import { Brain, Rocket, Shield, Users, Code, Target, Sparkles, Trophy } from 'lucide-react';
import SolutionsDialog from '../solutions/SolutionsDialog';

const values = [
  {
    id: 1,
    title: 'Innovation First',
    description: 'Pioneering AI-driven solutions that reshape digital experiences',
    icon: Brain,
    gradient: 'from-purple-600 to-indigo-600'
  },
  {
    id: 2,
    title: 'Client Success',
    description: 'Dedicated to delivering measurable results and exceptional value',
    icon: Trophy,
    gradient: 'from-pink-600 to-rose-600'
  },
  {
    id: 3,
    title: 'Technical Excellence',
    description: 'Cutting-edge expertise in AI and web development',
    icon: Code,
    gradient: 'from-blue-600 to-cyan-600'
  },
  {
    id: 4,
    title: 'Future-Ready',
    description: 'Building solutions that evolve with technology',
    icon: Rocket,
    gradient: 'from-green-600 to-emerald-600'
  },
  {
    id: 5,
    title: 'Security Focused',
    description: 'Enterprise-grade protection for your digital assets',
    icon: Shield,
    gradient: 'from-orange-600 to-red-600'
  },
  {
    id: 6,
    title: 'Global Reach',
    description: 'Serving clients worldwide from US and Philippines',
    icon: Target,
    gradient: 'from-violet-600 to-purple-600'
  }
];

export default function TeamSection() {
  const [showConsultation, setShowConsultation] = useState(false);

  return (
    <section className="py-16 bg-gray-50 dark:bg-gray-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <div className="flex items-center justify-center mb-4">
            <Sparkles className="w-8 h-8 text-purple-600" />
          </div>
          <h2 className="text-3xl font-bold text-gray-900 dark:text-white sm:text-4xl">
            Why Choose Pino AI
          </h2>
          <p className="mt-4 text-lg text-gray-600 dark:text-gray-300 max-w-3xl mx-auto">
            As a forward-thinking startup launched in 2024, we combine innovative AI technology 
            with deep industry expertise to deliver exceptional digital solutions.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {values.map((value) => (
            <div
              key={value.id}
              className="relative group bg-white dark:bg-gray-900 rounded-xl shadow-lg p-6 overflow-hidden hover:shadow-xl transition-all duration-300"
            >
              <div className={`absolute inset-0 bg-gradient-to-r ${value.gradient} opacity-0 group-hover:opacity-10 transition-opacity duration-300`} />
              <div className="relative">
                <div className="inline-flex p-3 rounded-lg bg-gradient-to-r from-purple-600 to-indigo-600 mb-4 group-hover:scale-110 transition-transform duration-300">
                  <value.icon className="w-6 h-6 text-white" />
                </div>
                <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-2">
                  {value.title}
                </h3>
                <p className="text-gray-600 dark:text-gray-300">
                  {value.description}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-16 text-center">
          <button
            onClick={() => setShowConsultation(true)}
            className="inline-flex items-center px-6 py-3 border border-transparent text-base font-medium rounded-md text-white bg-purple-600 hover:bg-purple-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-purple-500 transition-colors duration-300"
          >
            Start Your Digital Transformation
          </button>
        </div>

        <SolutionsDialog 
          isOpen={showConsultation}
          onClose={() => setShowConsultation(false)}
        />
      </div>
    </section>
  );
}